export const VIEW_EDIT_SETTINGS_POSTS = "viewEditSettingsPosts";
